module.exports = __webpack_public_path__ + "static/mongodb-b1847af9e7cf00cbe2d44e9fa173d281.svg";